// @flow

import React from 'react';
import Typography from '@mui/material/Typography';
import ChallengeDetailsHeaderCard from '../main-view-challenges/ChallengeDetailsHeaderCard.react';

function ChampsToPlayHeaderCard(): React.Element {
  return (
    <ChallengeDetailsHeaderCard
      title="Champs To Play"
      moreDetails={
        <Typography variant="body2" gutterBottom component="div">
          Organize your champion priorities with a personal ranked list. Mark champions you want to focus on, customize their order, and add notes about your goals.
        </Typography>
      }
      description="💡 Your list is saved locally and persists across sessions"
      borderClass="ratedBorder NONE"
    />
  );
}

export default ChampsToPlayHeaderCard;
